'use client';

import { create } from 'zustand';

interface PinAdToBottomStoreState {
  isShow: boolean;
  isEntered: boolean;
}

interface PinAdToBottomStoreActions {
  setShowOnce: () => void;
}

type PinAdToBottomStore = PinAdToBottomStoreState & PinAdToBottomStoreActions;

export const usePinAdToBottomStore = create<PinAdToBottomStore>((set, get) => ({
  isShow: false,
  isEntered: false,
  setShowOnce: () => {
    if (!get().isEntered) {
      set({ isShow: true, isEntered: true });
    }
  }
}));
